export default __webpack_public_path__ + "static/media/email icon 1.709e96d9.svg";